/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Logo from '../../assets/img/derby-logo.png'
import Trophy from '../../assets/trophy.png'
import Calendar from '../../assets/calendar.png'
import "./style.css" 
import { db, storage } from "../Firebase/firebase.js";

import * as MaterialIcons from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import { ListItem, ListItemAvatar, ListItemText, Avatar, Grid, Select, MenuItem, InputLabel, List } from '@material-ui/core'

import { Container, Navbar, Nav, NavDropdown, Carousel } from 'react-bootstrap';


const LandingPage = () => {

    const [events, setEvents] = useState([])
    const [winners, setWinners] = useState([])
    const [fishTypes, setFishTypes] = useState(["Brook Trout", "Cusk", "Largest Perch", "Muskie", "Salmon", "Togue"])
    const [selectedEvent, setselectedEvent] = useState(-1)
    const [selectedFish, setselectedFish] = useState(-1)

    useEffect(() => {
        getEvents()
    }, [])

    useEffect(() => {

        getWinners()
        // getFishTypes();
    }, [selectedFish, selectedEvent]);


    const getEvents = () => {
        let newArray = [];
        db.collection("events")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    newArray.push(doc.data());
                });
                setEvents(newArray);
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }

    // const getFishTypes = () => {
    //     let newArray = [];
    //     db.collection("fishRegistration")
    //         .get()
    //         .then((querySnapshot) => {
    //             querySnapshot.forEach((doc) => {

    //                 newArray.push(doc.id);

    //             });
    //             setFishTypes(newArray);
    //         })
    //         .catch((error) => {
    //             console.log("Error getting documents: ", error);
    //         });
    // }

    const getWinners = () => {
        let newArray = []
        var query = db.collection("fishRegistration")
            .doc(selectedFish === -1 ? "Brook Trout" : selectedFish)
            .collection(selectedFish === -1 ? "Brook Trout" : selectedFish);
        if (selectedEvent !== -1)
            query = query.where("eventId", "==", selectedEvent);

        query.get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    newArray.push(doc.data());
                });
                newArray.sort(function (a, b) {
                    if (a.weight === b.weight) {
                        return (b.length - a.length)
                    }
                    else {
                        return (b.weight - a.weight)

                    }
                }).splice(0, 4)
                setWinners(newArray)
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }


    return <>
        <Navbar style={{ backgroundColor: "#171942" }} variant="dark" expand="lg">
            <Container>
                <Navbar.Brand href="#home">
                    <img src={Logo} style={{ marginRight: 20 }} height="40" />
                    Ice Fishing Derby</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <Nav.Link href="/customerlogin" style={{ margin: "0 10px" }} >
                            <MaterialIcons.Lock style={{ transform: "scale(0.7)" }} />
                            <span style={{ margin: "0 5px", }}>Login</span>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>

        <Carousel>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://firebasestorage.googleapis.com/v0/b/ice-fishing-derby.appspot.com/o/prizes%2F1%20(1).jpg?alt=media&token=3445b815-8aa7-4706-9130-de7831530c2d"
                    alt="First slide"
                />
                <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://firebasestorage.googleapis.com/v0/b/ice-fishing-derby.appspot.com/o/landingpage%2F2%20(1).jpg?alt=media&token=baea250d-2248-4fa2-b7e9-a5930821c1b2"
                    alt="First slide"
                />
                <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://firebasestorage.googleapis.com/v0/b/ice-fishing-derby.appspot.com/o/landingpage%2F3.jpeg?alt=media&token=fae0d916-858d-4fac-a3ad-c04d4f221c89"
                    alt="First slide"
                />
                <Carousel.Caption>
                    <h3>Second slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>

        <Grid container spacing={2} justify="space-around" style={{ overflowY: "scroll", padding: 20, }}>
            <Grid item md={5} sm={12}>
                <h4>
                    <img src={Calendar} height="35" style={{ marginRight: 10 }} />
                    Recent Event
                </h4>

                <Grid container spacing={2} justify="flex-start">
                    {events.map((element, index) => (
                        <EventCard key={index} title={element.name} date={element.startDate} />
                    ))}
                </Grid>


            </Grid>

            <Grid item md={4} sm={12}>
                <Grid container justify="center" spacing="2">

                    <Grid item md={6}>
                        <h4>
                            <img src={Trophy} height="35" style={{ marginRight: 10 }} />
                            Leaderboard
                        </h4>
                    </Grid>
                    <Grid item md={3} sm={12}>

                        <Select value={selectedFish}
                            className="drop"
                            onChange={e => {
                                setselectedFish(e.target.value);
                            }}

                        >
                            {/* Map Fish over here */}
                            <MenuItem disabled={true} value={-1}>Fish type</MenuItem>
                            {fishTypes.map((e, i) => {
                                return <MenuItem key={i} value={e} >{e}</MenuItem>
                            })}
                        </Select>
                    </Grid>
                    <Grid item md={3} sm={12}>
                        <Select
                            label="Event"
                            className="drop"
                            value={selectedEvent}
                            onChange={e => {
                                setselectedEvent(e.target.value);
                            }}
                        >
                            {/* Map events here */}
                            <MenuItem value={-1} >Event</MenuItem>
                            {events.map((e, i) => {
                                return <MenuItem value={e.eventId} >{e.name}</MenuItem>
                            })}
                        </Select>
                    </Grid>

                </Grid>
                <Grid item style={{ height: 200, overflow: "scroll", overflowX: "auto" }}>
                    <Grid container justify="center" >

                        {
                            winners.length !== 0 ?
                                winners.map((element, index) => (
                                    <LeaderboardCard key={index} title={element.username} position={++index} subtitle={element.type + " - " + element.weight + " - " + element.length} />
                                )) : <Grid item>
                                    <p>No winner in this fish category and event.</p>
                                </Grid>}

                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    </>
}

const LeaderboardCard = ({ title, subtitle, position }) => {
    return <Grid item md={10} sm={10} >
        <ListItem className="leaderboard-entry">
            <ListItemAvatar>
                <Avatar variant="circle" style={{
                    backgroundColor: position == 1 ? "purple" : position == 2 ? "orange" : position == 3 ? "yellowgreen" : "blue",

                }}>{position}</Avatar>
            </ListItemAvatar>
            <ListItemText>
                <h5>{title}</h5>
                <h6>{subtitle}</h6>
            </ListItemText>
            <br />
        </ListItem>
    </Grid>

}

const EventCard = ({ title, date, onClick }) => {
    return <Grid item md={6} onClick={onClick}>
        <ListItem className="leaderboard-entry">
            <ListItemAvatar>
                <Avatar style={{ backgroundColor: "orange" }} variant="circle">A</Avatar>
            </ListItemAvatar>
            <ListItemText>
                <h5>{title}</h5>
                <h6>
                    <MaterialIcons.CalendarToday style={{ marginRight: 5 }} />
                    {date}
                </h6>
            </ListItemText>
        </ListItem>
    </Grid>
}



export default LandingPage;